export const environment = {
  production: true,
  hmr: false,
  canonicalDomain: 'https://teamfoster.nl',
  clarityProjectId: 'v8jwhhhafk',
};
